import * as React from "react";
import s from "./nav.scss";
import ZigLogo from "#components/primitive/menu/v2/logo.svg";
import { smoothScrollTo } from "../../utils/smooth-scroll";
import { navContent } from "./content";

interface NavProps {
	isScrolled: boolean;
}

function handleNavClick(
	e: React.MouseEvent<HTMLAnchorElement>,
	targetId: string,
	onClose?: () => void,
) {
	e.preventDefault();
	smoothScrollTo(targetId, 1000);
	onClose?.();
}

export function Nav({ isScrolled }: NavProps) {
	const [isMenuOpen, setIsMenuOpen] = React.useState(false);
	const menuRef = React.useRef<HTMLDivElement>(null);

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	const closeMenu = () => {
		setIsMenuOpen(false);
	};

	// Fecha o menu quando clicar fora
	React.useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
				closeMenu();
			}
		};

		if (isMenuOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isMenuOpen]);

	return (
		<nav className={`${s.nav} ${isScrolled ? s.scrolled : ""}`} ref={menuRef}>
			<div className={s.navContent}>
				<div className={s.logoWrapper}>
					<ZigLogo />
				</div>

				<button
					className={`${s.hamburger} ${isMenuOpen ? s.active : ""}`}
					onClick={toggleMenu}
					aria-label="Menu"
				>
					<span />
					<span />
					<span />
				</button>

				<div className={`${s.navLinks} ${isMenuOpen ? s.open : ""}`}>
					<a href="#operacao" onClick={e => handleNavClick(e, "operacao", closeMenu)}>
						{navContent.tempoOperacao}
					</a>
					{/* <a href="#destaques" onClick={e => handleNavClick(e, "destaques", closeMenu)}>
						{navContent.destaques}
					</a> */}
					<a href="#revelacoes" onClick={e => handleNavClick(e, "revelacoes", closeMenu)}>
						{navContent.revelacoes}
					</a>
					<a href="#fluxo" onClick={e => handleNavClick(e, "fluxo", closeMenu)}>
						{navContent.faturamento}
					</a>
					<a href="#ranking" onClick={e => handleNavClick(e, "ranking", closeMenu)}>
						{navContent.ranking}
					</a>
					<a
						href="#curiosidades"
						onClick={e => handleNavClick(e, "curiosidades", closeMenu)}
					>
						{navContent.curiosidades}
					</a>
				</div>
			</div>
		</nav>
	);
}
